<template>
  <v-card>
    <v-card-title>
      <p class="ma-auto">{{ titleChanged }}</p>
    </v-card-title>
    <v-card-actions class="d-flex justify-space-around pb-4">
      <v-btn class="bt-exit" @click="cancelChanged">{{
        $tc("commons.cancel")
      }}</v-btn>
      <v-btn class="bt-acept" text @click="confirmChanged">{{
        $tc("commons.accept")
      }}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    titleChanged: String,
  },
  methods: {
    cancelChanged() {
      this.$emit("cancelChanged");
    },
    confirmChanged() {
      this.$emit("confirmChanged");
    },
  },
};
</script>

<style scoped>
.bt-exit {
  color: white !important;
  background-color: #e2504c !important;
}
.bt-acept {
  background-color: #77dd77 !important;
  color: white !important;
}
</style>
